export default {
  SET_TASK_LIST(state, tasks) {
    state.list = tasks;
  },
};
